import { render, staticRenderFns } from "./GroupUser.vue?vue&type=template&id=511604d8&scoped=true"
import script from "./GroupUser.vue?vue&type=script&lang=js"
export * from "./GroupUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511604d8",
  null
  
)

export default component.exports